import { Button } from '@/shared/components/Button';
import Input, {
	DefaultForm,
	FormTextAreaField,
} from '@/shared/components/ReusableForm';
import renderTextField from '@/shared/components/ReusableForm/components/TextField';
import SimpleLoader from '@/shared/components/SimpleLoader';
import {
	ButtonWrap,
	MaterialFormContainer,
} from '@/shared/components/form/MaterialFormElements';
import renderDropZoneField from '@/shared/components/form/dropzones/DropZone';
import { useState } from 'react';

import { createHelpTicket } from '@/redux/actions/gpuActions';
import { attachFileToJiraTicketByKey } from '@/redux/actions/jiraActions';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import validation from '../validate/createHelpValidate';

const GpuOneCreateHelpForm = ({ toggle, setIsOpen, row }) => {
	const [isLoading, setIsLoading] = useState(false);
	const dispatch = useDispatch();
	const initialValues = {
		hostname: row?.hostname,
		machine_name: row?.machine_name,
		machine_status: row?.machine_status,
		deployed_os: row?.deployed_os,
		total_memory: row?.total_memory,
		total_cpu_cores: row?.total_cpu_cores,
		cpu_type: row?.cpu_type,
	};

	const handleSubmit = async values => {
		try {
			setIsLoading(true);
			const data = {
				question: values.description,
			};

			// Create the help ticket first (without auto-toggle)
			const response = await dispatch(
				createHelpTicket(row?.system_serial, data, null),
			);

			// If there's a file attached and we have a ticket key, upload the attachment
			if (
				values.attachments &&
				values.attachments.length > 0 &&
				response?.key
			) {
				await dispatch(
					attachFileToJiraTicketByKey(response.key, values.attachments),
				);
			}

			// Close the form after successful submission
			toggle();
		} catch (error) {
			console.error('Error submitting help form:', error);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<>
			<DefaultForm
				onSubmit={handleSubmit}
				validate={validation}
				initialValues={initialValues}
			>
				{({ handleSubmit, form }) => (
					<MaterialFormContainer onSubmit={handleSubmit}>
						<Input
							variant="standard"
							name="machine_name"
							label="Machine Name"
							readOnly
							component={renderTextField}
						/>
						<Input
							variant="standard"
							name="machine_status"
							label="Machine Status"
							readOnly
							component={renderTextField}
						/>
						<Input
							variant="standard"
							name="deployed_os"
							label="Deployed OS"
							readOnly
							component={renderTextField}
						/>
						<Input
							variant="standard"
							name="total_cpu_cores"
							label="Total CPU Cores"
							readOnly
							component={renderTextField}
						/>

						<Input
							variant="standard"
							name="cpu_type"
							label="CPU Type"
							readOnly
							component={renderTextField}
						/>
						<FormTextAreaField
							name="description"
							label="How can we Help you?"
							placeholder="How can we Help you?"
						/>
						<FileUploadSection>
							<FileUploadLabel>Attach Screenshot (Optional)</FileUploadLabel>
							<Input name="attachments" component={renderDropZoneField} />
						</FileUploadSection>
						<ButtonWrap>
							<Button variant="primary" type="submit" disabled={isLoading}>
								{isLoading ? (
									<LoadingWrap>
										<SimpleLoader widthOrHeight={32} />
									</LoadingWrap>
								) : (
									'Submit'
								)}
							</Button>
							<Button
								variant="secondary"
								type="button"
								onClick={() => {
									toggle();
									form.reset();
									setIsOpen(false);
								}}
							>
								Cancel
							</Button>
						</ButtonWrap>
					</MaterialFormContainer>
				)}
			</DefaultForm>
		</>
	);
};

export default GpuOneCreateHelpForm;

const LoadingWrap = styled.div`
	display: flex;
	justify-content: center;
	font-size: 12px;
	align-items: center;
	height: 25px;
`;

const FileUploadSection = styled.div`
	margin: 20px 0;
`;

const FileUploadLabel = styled.label`
	display: block;
	margin-bottom: 8px;
	font-size: 14px;
	font-weight: 500;
	color: #333;
`;
